// extracted by mini-css-extract-plugin
module.exports = {"dl":"style_dl__9Z11K","open":"style_open__4cO9E"};